import { render, staticRenderFns } from "./PrintingActivityPage.vue?vue&type=template&id=1509cb46&scoped=true&lang=pug&"
import script from "./PrintingActivityPage.vue?vue&type=script&lang=ts&"
export * from "./PrintingActivityPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrintingActivityPage.vue?vue&type=style&index=0&id=1509cb46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1509cb46",
  null
  
)

export default component.exports